<template>
  <div id="app" v-if="!loading">
    <div class="navContainer">
      <div id="logo" style="height: 45px; margin: 5px 0px 0px -30px; width: 120px; z-index: 1; position:relative; float: left;">
        <img src="/static/images/nucleus-logo.svg" height="100px;" />
      </div>
      <ul v-if="showNavbarItems" role="menubar" class="el-menu--horizontal el-menu" id="topNav" style="background-color: rgb(238, 238, 238);">
        <li id="homeTab" role="menuitem" tabindex="0" class="el-menu-item desktop" :class="getActiveClass('home')" style="color: rgb(255, 255, 255); border-bottom-color: transparent;background-color: rgb(238, 238, 238);">
          <router-link v-bind:to="`/${currentClientId}`"> <i class="mdi mdi-home-variant" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>Home </router-link>
        </li>

        <li id="dashboardTab" v-if="codingDashboard() || reviewDashboard()" role="menuitem" tabindex="1" class="el-menu-item desktop" :class="getActiveClass('dashboard')" style="color: rgb(255, 255, 255); border-bottom-color: transparent;background-color: rgb(238, 238, 238);">
          <el-menu class="topNavDashboardMenu" mode="horizontal" background-color="rgb(238, 238, 238)" text-color="#999999" active-text-color="#333333">
            <el-submenu index="dashboardSub" id="dashboardSub" popper-class="dashboardSubmenuPopper">
              <template slot="title">
                <i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>Dashboards
              </template>
              <el-menu-item v-if="codingDashboard()" index="codingDashboard" id="codingDashboardSubItem">
                <router-link v-bind:to="`/${currentClientId}/dashboard/coding`" style="width: 100%;"> <div style="width: 100%;">Coding Support</div></router-link>
              </el-menu-item>
              <el-menu-item v-if="reviewDashboard()" index="reviewDashboard" id="reviewDashboardSubItem">
                <router-link v-bind:to="`/${currentClientId}/dashboard/review`" style="width: 100%;"> <div style="width: 100%;">Coding Review</div></router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </li>
        <li id="requestsTab" v-if="nucleusUser()" role="menuitem" tabindex="2" class="el-menu-item desktop" :class="getActiveClass('requests')" style="color: rgb(255, 255, 255); border-bottom-color: transparent; background-color: rgb(238, 238, 238);">
          <router-link v-bind:to="`/${currentClientId}/requests`"> <i class="mdi mdi-buffer" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>Requests </router-link>
        </li>
        <li id="documentManagerTab" v-if="nucleusUser()" role="menuitem" tabindex="3" class="el-menu-item desktop" :class="getActiveClass('documents')" style="color: rgb(255, 255, 255); border-bottom-color: transparent; background-color: rgb(238, 238, 238);">
          <router-link v-bind:to="`/${currentClientId}/documents`"> <i class="mdi mdi-folder-multiple-outline" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>Document Manager </router-link>
        </li>
        <li id="codingQuestions" role="menuitem" tabindex="4" class="el-menu-item desktop" :class="getActiveClass('coding-questions')" style="color: rgb(255, 255, 255); border-bottom-color: transparent; background-color: rgb(238, 238, 238);">
          <router-link v-bind:to="`/${currentClientId}/coding-questions`"> <i class="mdi mdi-comment-question-outline" style="font-size: 17px; margin: 0px 5px 0px 0px; background: transparent;"></i>Coding Questions </router-link>
        </li>
        <li v-if="rebuttalUser() || rebuttalManager()" id="myProjectsTab" role="menuitem" tabindex="3" class="el-menu-item desktop" :class="getActiveClass('my-projects')" style="color: rgb(255, 255, 255); border-bottom-color: transparent; background-color: rgb(238, 238, 238);">
          <router-link v-bind:to="`/${currentClientId}/my-projects`"> <i class="mdi mdi-file-document-box-multiple-outline" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>My Projects </router-link>
        </li>
        <el-menu id="profileMenu" :router="true" mode="horizontal" background-color="#eeeeee">
          <el-submenu id="navProfile" index="4" class="pull-right">
            <template slot="title">
              <avatar class="desktop" :fullname="user.name" :image="user.imageData" :size="30"></avatar>
              <span class="tabletNavIcon">
                <i class="mdi mdi-menu"></i>
              </span>
            </template>
            <el-menu-item class="profileSubItem tabletMenuItem" :index="`/${currentClientId}`"> <i class="mdi mdi-home-outline" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Home </el-menu-item>
            <el-menu-item v-if="codingDashboard()" class="profileSubItem tabletMenuItem" :index="`/${currentClientId}/dashboard/coding`"> <i class="mdi mdi-airplay" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Coding Support Dashboard </el-menu-item>
            <el-menu-item v-if="reviewDashboard()" class="profileSubItem tabletMenuItem" :index="`/${currentClientId}/dashboard`"> <i class="mdi mdi-clipboard-check-outline" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Coding Review Dashboard </el-menu-item>
            <el-menu-item v-if="nucleusUser()" class="profileSubItem tabletMenuItem" :index="`/${currentClientId}/requests`"> <i class="mdi mdi-buffer" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Requests </el-menu-item>
            <el-menu-item v-if="nucleusUser()" class="profileSubItem tabletMenuItem" :index="`/${currentClientId}/documents`"> <i class="mdi mdi-folder-multiple-outline" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Document Manager </el-menu-item>
            <el-menu-item class="profileSubItem tabletMenuItem" :index="`/${currentClientId}/coding-questions`"> <i class="mdi mdi-comment-question-outline" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Coding Questions </el-menu-item>
            <el-menu-item v-if="rebuttalUser() || rebuttalManager()" class="profileSubItem tabletMenuItem" :index="`/${currentClientId}/my-projects`"> <i class="mdi mdi-file-document-box-multiple-outline" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>My Projects </el-menu-item>
            <div class="tabletMenuItem" style="border-bottom: 1px solid #999999; width: 90%; margin: 0 auto; height: 1px;"></div>
            <el-menu-item class="profileSubItem tabletMenuItem" index @click="SET_SHOWNOTIFICATIONS(true)">
              <el-badge :value="notificationData.filter(f => f.acknowledged === false).length" :max="99" class="badgeItem" :hidden="notificationData.filter(f => f.acknowledged === false).length ? false : true"> <i style="margin-left: -4px; margin-right: 1px;" class="el-icon-bell"></i>Notifications </el-badge>
            </el-menu-item>
            <el-menu-item class="profileSubItem" index @click="changePassword"> <i class="mdi mdi-account-key" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Change Password </el-menu-item>
            <el-menu-item v-if="documentManagerAdmin() || userAdmin()" class="profileSubItem" index @click="nucleusUserAdmin"> <i class="mdi mdi-account-supervisor" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>User Admin </el-menu-item>
            <el-menu-item class="profileSubItem" index @click="logout"> <i class="mdi mdi-logout-variant" style="font-size: 16px;margin: 0px 5px 0px 0px; background: transparent;"></i>Logout </el-menu-item>
          </el-submenu>
        </el-menu>
        <li id="notificationsTab" role="menuitem" tabindex="5" class="el-menu-item pull-right" style="color: rgb(255, 255, 255); border-bottom-color: transparent; background-color: rgb(238, 238, 238);" @click="SET_SHOWNOTIFICATIONS(true)">
          <el-badge :value="notificationData.filter(f => f.acknowledged === false).length" :max="99" class="badgeItem" :hidden="notificationData.filter(f => f.acknowledged === false).length ? false : true">
            <span>
              <i class="el-icon-bell"></i>
            </span>
          </el-badge>
        </li>
        <div index="3" class="pull-right tabletClientSelect" tabindex="0" style="margin-top: 10px; margin-right: 10px; outline: none;">
          <!-- client dropdown component goes here -->
          <el-tag v-if="!currentClientComputed && clients.length > 0" size="large" style="background: #f56c6c; color: #ffffff; margin-top: 5px;width: 300px; font-weight: 300;">
            No Access to Client. Please Contact HIA.
          </el-tag>
          <el-tag v-if="clients.length === 0" size="large" style="background: #f56c6c; color: #ffffff; margin-top: 5px;width: 300px; font-weight: 300;">
            No Clients Assigned. Please Contact HIA.
          </el-tag>
        </div>
      </ul>
    </div>
    <el-container>
      <el-main class="mainContainer">
        <el-alert class="acpWarning" v-if="currentClientACPReview" type="warning" :description="`${currentClientHeaderTextReviews}`" center show-icon :closable="false"> </el-alert>
        <notificationBanner></notificationBanner>
        <keep-alive include="coderProject,coderProjectList,coderInpatientList,coderOutpatientList,coderProList">
          <router-view v-if="!loadingNewClient && currentClientComputed" style="margin-bottom: 30px;" class="top-margin"> </router-view>
        </keep-alive>
        <template v-if="!loadingNewClient && !currentClientComputed && clients.length > 0">
          <h1 class="page-header">No Access</h1>
          You do not have access to the requested client. Please contact HIA and/or return <router-link to="/">home</router-link>.
        </template>
      </el-main>
      <el-footer id="footer">
        <div style="width: 100%">
          <div class="skyBlueFooter"></div>
          <div class="goldFooter"></div>
          <div class="magentaFooter"></div>
          <div class="greenFooter"></div>
          <div class="skyBlueFooter"></div>
          <div class="goldFooter"></div>
          <div class="magentaFooter"></div>
          <div class="greenFooter"></div>
          <div class="skyBlueFooter"></div>
          <div class="goldFooter"></div>
          <div class="magentaFooter"></div>
          <div class="greenFooter"></div>
          <div class="skyBlueFooter"></div>
          <div class="goldFooter"></div>
          <div class="magentaFooter"></div>
          <div class="greenFooter"></div>
        </div>
        <el-row class="footerContainer">
          <el-col :span="12" style="padding: 2% 0px 0px 0px;">
            <div style="height: 45px;">
              <img src="/static/images/hia-logo-horizontal-white-small.png" height="100%" />
            </div>
            <p class="hiaFooterDetails">&copy; {{ getCurrentYear() }} Health Information Associates</p>
          </el-col>
          <el-col :span="12" style="padding: 2% 0px 0px 0px;">
            <p class="hiaFooterRightLinks pull-right">
              <a href="mailto:nucleus@hiacode.atlassian.net">Support</a>
            </p>
            <p class="hiaFooterRightLinks pull-right">
              <a href="https://hiacode.com/privacy-policy" target="_blank">Privacy Policy</a>
            </p>
            <p class="hiaFooterRightLinks pull-right">
              <a href="https://hiacode.com/legal" target="_blank">Legal</a>
            </p>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
    <!-- drawer  -->
    <notificationsView></notificationsView>
    <!-- end drawer  -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import avatar from '@/components/avatar'
import notificationBanner from '@/components/notifications/notificationBanner'
import notificationsView from '@/components/notifications/notificationsView'
import dateHelper from '@/mixins/date-helper'

export default {
  name: 'app',
  mixins: [HiaAuthorization, dateHelper],
  data() {
    return {
      loading: false,
      loadingNewClient: false,
      showNavbarItems: true,
      localClients: []
    }
  },
  methods: {
    ...mapActions(['GET_BUILD_NUMBER']),
    ...mapActions('user/', ['CHANGE_PASSWORD', 'GET_PROFILEPHOTO']),
    ...mapMutations(['SET_BUILD_NUMBER']),
    ...mapMutations('user/', ['SET_USER', 'SET_CURRENT_CLIENT', 'SET_CURRENT_CLIENT_BY_ID']),
    ...mapMutations('dashboard/', ['CLEAR_REVIEW_DASHBOARD']),
    ...mapMutations('notifications/', ['SET_SHOWNOTIFICATIONS']),
    login() {
      window.location.href = '/'
    },
    logout() {
      this.user.logout()
    },
    changePassword() {
      this.CHANGE_PASSWORD()
    },
    showParticleUpdateMessage() {
      // create vnode
      const h = this.$createElement
      this.$message({
        showClose: false,
        message: h('span', null, [
          'Client Portal Update Available.  Please ',
          h(
            'span',
            {
              on: {
                click: function() {
                  location.reload(true)
                }
              },
              attrs: { id: 'systemUpdateLink' }
            },
            'Refresh'
          )
        ]),
        duration: 0,
        type: 'warning'
      })
    },
    changeBodyBackground() {
      document.body.style.background = '#1c3c5f'
    },
    formatName() {
      if (!this.user.name) {
        return ''
      }

      let name = this.user.name.split(' ').map(i => i.charAt(0).toUpperCase())
      if (name.length > 1) {
        return name[0] + name[1]
      } else {
        return ''
      }
    },
    getLongCurrentClient() {
      let fullClientName = this.clients.filter(f => f.clientNumber).map(i => i.clientName)[0]
      return this.currentClient + ' | ' + fullClientName
    },
    getActiveClass(tabName) {
      let path = window.location.pathname
      switch (true) {
        case path.includes('dashboard'):
          return tabName === 'dashboard' ? 'is-active' : ''
        case path.includes('request'):
          return tabName === 'requests' ? 'is-active' : ''
        case path.includes('documents'):
          return tabName === 'documents' ? 'is-active' : ''
        case path.includes('reports'):
          this.$router.push(`/${this.currentClientId}`)
          return tabName === 'reports' ? 'is-active' : ''
        case path.includes('coding-questions'):
          return tabName === 'coding-questions' ? 'is-active' : ''
        case path.includes('my-projects'):
          return tabName === 'my-projects' ? 'is-active' : ''
        default:
          return tabName === 'home' ? 'is-active' : ''
      }
    },
    clientNumberFilter(query) {
      this.localClients = this.clients.filter(x => {
        return query.length > 5 ? x.clientName.toLowerCase().indexOf(query.toLowerCase()) > -1 : x.clientNumber.toLowerCase().substring(0, query.length) === query.toLowerCase()
      })
    },
    nucleusUserAdmin() {
      this.$router.push(`/${this.currentClientId}/user-admin`)
    }
  },
  created: function() {
    this.localClients = JSON.parse(JSON.stringify(this.clients))
    this.GET_PROFILEPHOTO(this.user.email).then(() => {
      this.$forceUpdate()
    })
    this.GET_BUILD_NUMBER().then(response => {
      try {
        // set build number
        if (response !== undefined) {
          this.SET_BUILD_NUMBER(response.data.buildNumber)
          window.buildNumber = response.data.buildNumber
        }
      } catch (e) {}
    })
  },
  mounted: function() {
    this.changeBodyBackground()
  },
  computed: {
    ...mapState('notifications/', ['showNotifications', 'notificationData']),
    ...mapState(['showUpdateMessage']),
    ...mapState('user/', ['user', 'currentClient', 'currentClientId', 'clients', 'currentClientACPReview', 'currentClientName', 'currentClientHeaderTextReviews']),
    ...mapState('home/', ['clientNavSelection']),
    currentClientComputed: {
      get: function() {
        return this.currentClient
      },
      set: function(newVal) {
        // run this through a custom setter so we can set local storage instead of using vue-map-fields
        this.loadingNewClient = true

        // nuke current dashboard
        this.CLEAR_REVIEW_DASHBOARD('')

        let client = this.clients.find(x => x.clientNumber === newVal)
        this.SET_CURRENT_CLIENT(client)
        this.$router.push({
          name: this.$route.meta.parent ? this.$route.meta.parent : '/',
          params: { clientId: this.currentClientId }
        })
        // force everything to reload with the new client
        this.$nextTick(() => {
          window.location.reload()
          this.loadingNewClient = false
        })
      }
    }
  },
  watch: {
    showUpdateMessage: function() {
      if (this.showUpdateMessage) {
        this.showParticleUpdateMessage()
      }
    },
    clientNavSelection: function() {
      if (this.clientNavSelection.length) {
        this.currentClientComputed = this.clientNavSelection
      }
    }
  },
  components: {
    avatar,
    notificationBanner,
    notificationsView
  }
}
</script>

<style>
#app {
  min-height: 100%;
}

p,
h1,
h2,
h3,
h4 {
  font-weight: normal;
}

a {
  color: #337ab7;
  text-decoration: none;
}

.mainContainer {
  padding-right: 65px !important;
  padding-left: 65px !important;
  min-height: 75vh;
  background-color: #ffffff;
  /* padding: 0px !important; */
}

.el-breadcrumb {
  padding-bottom: 12px;
  margin-bottom: 35px;
}

.el-breadcrumb .el-breadcrumb__inner {
  font-size: 14px;
  color: #909399;
}

.el-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 600;
  color: #909399;
}

.hia-el-input {
  height: 22px;
  border: 1px solid #b4bccc;
}

.el-input.is-disabled .el-input__inner,
.el-textarea.is-disabled .el-textarea__inner {
  color: black !important;
  background-color: #eaeaea !important;
}

.myProjects .el-input--mini .el-input__inner {
  height: 22px !important;
  line-height: 22px !important;
}

.myProjects .el-form--label-top .el-input--mini {
  margin-top: 8px;
}

.myProjects .el-form-item--mini.el-form-item,
.myProjects .el-form-item--small.el-form-item {
  margin-bottom: 8px !important;
}

.myProjects .el-form-item--mini .el-form-item__content,
.myProjects .el-form-item--mini .el-form-item__label {
  line-height: 1 !important;
}

.myProjects .el-input--mini .el-input__icon {
  line-height: 22px !important;
}

.myProjects div.el-input--mini > input[style*='height: 28px;'] {
  height: 22px !important;
}

.myProjects .el-form-item__label {
  vertical-align: middle !important;
  float: left !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #48576a !important;
  line-height: 1 !important;
  padding: 6px 0 0 !important;
  box-sizing: border-box !important;
}

/* accordion */
.myProjects .el-collapse-item__header {
  height: 40px !important;
  padding-left: 2px;
  border-bottom: 1px solid #b4bccc;
}

.myProjects .el-collapse-item.is-active .el-collapse-item__header {
  background-color: #eee;
}

.myProjects .el-collapse-item__header:hover {
  background-color: #eee;
}

.myProjects .el-collapse-item__wrap {
  margin-top: 15px;
}

.popover {
  word-break: break-word !important;
  text-align: left !important;
}

.el-popover {
  box-shadow: 0 6px 12px 0 rgb(0 0 0 / 30%) !important;
  border: 1px solid #e6a23c !important;
}

.el-popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: #e6a23c !important;
}

.el-popper[x-placement^='top'] .popper__arrow {
  border-top-color: #e6a23c !important;
}

.el-popper[x-placement^='left'] .popper__arrow {
  border-left-color: #e6a23c !important;
}

.el-popper[x-placement^='right'] .popper__arrow {
  border-right-color: #e6a23c !important;
}

.headerWithBorder {
  padding-bottom: 5px;
  margin: 0px 0px 15px 0px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  color: rgb(119, 119, 119);
}

.headerWithBorderDark {
  padding-bottom: 5px;
  margin: 0px 0px 15px 0px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  color: #48576a;
}

.dottedUnderline {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.el-main {
  overflow: inherit !important;
}

.actionButtons {
  list-style-type: none;
}

.pull-right {
  float: right !important;
}

.top-margin {
  margin-top: 20px;
}

.top-margin-30 {
  margin-top: 30px;
}

.heading {
  border-bottom: 1px solid #c0c4cc;
  padding-bottom: 8px;
}

#systemUpdateLink {
  color: #42b983;
  font-weight: bold;
  cursor: pointer;
}

.nav-link {
  text-decoration: none !important;
  line-height: 0px;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px !important;
}

/* TOP NAVIGATION SECTION */
#topNav li.el-menu-item {
  padding: 0 10px;
}

#topNav .el-submenu__title {
  background-color: unset !important;
  border-bottom: 0px !important;
  padding: 0px;
}

#topNav .el-submenu__icon-arrow {
  margin-left: 3px;
}

#topNav .topNavDashboardMenu {
  height: 100% !important;
  display: flex;
  align-items: center;
  width: 100% !important;
}

#topNav .topNavDashboardMenu .el-submenu {
  margin-top: 3px !important;
}

#topNav .is-active > .topNavDashboardMenu {
  background-color: transparent !important;
}

#topNav li i {
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
}

#topNav li a {
  display: inline-block;
}

/* Detached popper menu for Dashboards submenu (rendered at document root) */
.dashboardSubmenuPopper.el-menu--horizontal {
  transform: translate(-10px, 12px) !important; /* left, down */
}

.navContainer {
  background-color: #eeeeee;
  padding-right: 75px;
  padding-left: 75px;
  margin-right: auto;
  margin-left: auto;
  height: 60px;
  box-shadow: 1px 0 3px 0 rgba(0, 0, 0, 0.5);
  z-index: 1;
  position: relative;
}

/* IE only */
_:-ms-lang(x),
_:-webkit-full-screen,
.navContainer {
  box-shadow: 1px 0.5px 3px 0 rgba(0, 0, 0, 0.5);
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .navContainer {
    box-shadow: 1px 0.5px 3px 0 rgba(0, 0, 0, 0.5);
  }
}

@media screen and (min-width: 1580px) {
  .navContainer,
  .mainContainer,
  .footerContainer {
    padding-right: 200px !important;
    padding-left: 200px !important;
  }
}

.el-menu-item {
  color: #999999 !important;
}

.el-submenu__title {
  color: #999999 !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0.5) !important;
  border-bottom: 2px solid #005695 !important;
  color: #333333 !important;
}

/* PROFILE NAVIGATION  */

/*updated navProfile*/
#profileMenu {
  height: 60px;
  float: right;
}

#profileMenu > #navProfile {
  height: 60px;
}

#profileMenu > li > div.el-submenu__title {
  height: 60px;
  padding-top: 10px;
}

/* #navProfile>div:hover {
    background-color: rgba(255, 255, 255, .5) !important;
    color: #333333 !important;
    height: 60px;
  } */

#navProfile > div:hover {
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #333333 !important;
}

#navProfile > div > .el-submenu__icon-arrow {
  display: none;
}

.profileSubItem:hover {
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #333333 !important;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
}

.profileSubItem:hover i {
  color: #333333 !important;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
}

.profileSubItem i {
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
}

/* FOOTER SECTION  */
#footer {
  background: #1c3c5f;
  padding: 0px 0px 0px 0px !important;
  min-height: 150px !important;
}

.footerContainer {
  padding-right: 75px;
  padding-left: 75px;
  font-weight: 300;
  height: 100%;
  color: #ffffff;
  padding-bottom: 75px;
}

.hiaFooterDetails {
  font-size: 13px;
  margin: 3px 0px 0px 30px;
  opacity: 0.3;
}

.hiaFooterRightLinks a {
  font-size: 15px;
  margin: 3px 0px 0px 30px;
  color: #ffffff;
  opacity: 0.3;
  text-decoration: none;
}

.skyBlueFooter {
  width: 6.25%;
  height: 0.05in;
  background: #57ccf4;
  float: left;
}

.goldFooter {
  width: 6.25%;
  height: 0.05in;
  background: #ffc72e;
  float: left;
}

.magentaFooter {
  width: 6.25%;
  height: 0.05in;
  background: #f90089;
  float: left;
}

.greenFooter {
  width: 6.25%;
  height: 0.05in;
  background: #7cbe5f;
  float: left;
}

/* highcharts */
.highcharts-credits {
  display: none;
}

/* EL BUTTON */
.el-button {
  border-radius: 30px !important;
}

/* EL TABLE */
.el-table th > .cell {
  font-weight: 500 !important;
}

.el-table td,
.el-table th {
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
  border-bottom: 1px solid #ebeef5 !important;
}

/* tablet styles*/
.desktop {
  display: initial;
}

.tabletNavIcon {
  display: none;
}

.tabletMenuItem {
  display: none;
}

#navProfile .el-submenu__title {
  border-bottom-color: transparent !important;
}

.hiaTable {
  width: 100%;
}

/* hiatable */
.hiaTable .table-responsive {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.hiaTable table {
  border-top: 1px solid #b4bccc;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  width: 100%;
  border-collapse: collapse;
  color: #606266;
}

.hiaTable .VueTables__filters-row {
  background-color: black;
}

.hiaTable .VuePagination__count {
  font-size: 12px;
}

.hiaTable table tr th {
  font-size: 11px;
  line-height: 12px;
  padding: 5px;
  background: #eee;
  text-align: left;
  vertical-align: top;
  border: 1px solid #b4bccc;
}

.hiaTable td {
  border-top: 1px solid #b4bccc;
  border-bottom: 1px solid #b4bccc;
}

.hiaTable table tr td {
  font-size: 14px;
  line-height: 12px;
  padding: 6px 4px 6px 4px;
  border: 1px solid #b4bccc;
}

.hiaTable table tr:nth-child(odd) {
  background: rgba(109, 207, 246, 0.1);
}

.hiaTable table .VueTables__row:hover {
  background: rgba(255, 196, 12, 0.2) !important;
}

/* new hiatable styles */
.hiaTable table {
  border-top: 0px solid transparent;
}

.hiaTable td {
  border-top: 1px solid #ebeef5 !important;
  border-bottom: 1px solid #ebeef5 !important;
}

.hiaTable table thead tr th {
  background: #ffffff !important;
  border: 0px solid transparent !important;
  color: #909399;
  font-size: 12px;
  padding: 3px;
}

.hiaTable table tr td {
  font-size: 12px;
  line-height: 12px;
  padding: 6px 4px 6px 4px;
  border: 0px solid transparent;
}

.hiaTable .VueTables__filters-row input {
  font-size: 12px;
  height: 20px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  box-shadow: inset 0 0px 0px rgb(0 0 0 / 8%);
}

.hiaTable .VueTables__filters-row select {
  font-size: 12px;
  height: 20px;
  padding: 0;
}

.hiaTable .pagination {
  display: flex;
  padding-left: 0;
  margin: 20px 0px 0px 0px;
  border-radius: 4px;
}

.hiaTable .pagination > li:first-child > a,
.hiaTable .pagination > li:first-child > span {
  margin-left: 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.hiaTable .pagination > li > a,
.hiaTable .pagination > li > span {
  margin: 0 3px;
  font-size: 12px;
  position: relative;
  float: left;
  padding: 1px 8px;
  line-height: 22px;
  color: #606266;
  text-decoration: none;
  background-color: #f4f4f5;
  border: 0px solid transparent;
  border-radius: 2px;
  height: 22px;
  font-weight: 500;
}

.hiaTable .pagination > li > a.active {
  background-color: #005695;
  color: #fff;
  border-radius: 50%;
}

.hiaTable .VueTables__filters-row input {
  font-size: 13px;
  height: 24px;
  box-sizing: border-box;
}

.hiaTable .VueTables__filters-row select {
  font-size: 13px;
  height: 24px;
  padding: 0;
}

.hiaTable .VueTables__highlight b {
  background: #ffffe0;
}

.hiaTable .VueTables__limit {
  display: none;
}

.hiaTable .VueTables__highlight b {
  background: #ffffe0;
}

.form-control {
  display: block;
  width: 100%;
  height: 22px;
  padding: 6px 12px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

/* media queries */

@media screen and (max-width: 1310px) and (min-width: 0px) {
  /* navigation menu */
  .desktop {
    display: none !important;
  }

  .tabletClientSelect {
    float: none !important;
    margin: 0 auto !important;
    width: 300px;
    margin-top: 10px !important;
  }

  .tabletNavIcon {
    display: block;
    font-size: 35px;
  }

  .tabletMenuItem {
    display: block;
  }

  .el-menu--horizontal > .el-submenu .el-submenu__title {
    padding: 0 10px;
  }

  .hiaTable table {
    border-top: 1px solid #b4bccc;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    border-collapse: collapse;
    color: #606266;
    width: 100%;
  }

  /* main container */
  .navContainer,
  .mainContainer,
  .footerContainer {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }

  /* document manager */
  .actionButtons {
    padding-inline-start: 2px;
  }

  /* pro specialties modal */
  .cptPerProvider {
    margin-top: 30px;
  }
}

/* Tooltips */
.nucleusTooltip {
  width: 250px !important;
}

/* notification style */
#notificationsTab .el-badge__content {
  margin: 8px -12px 0px 0px;
  -webkit-animation: breathing 2s ease-out infinite normal;
  animation: breathing 2s ease-out infinite normal;
}

.profileSubItem .el-badge__content {
  margin: 17px -12px 0px 0px;
}

@-webkit-keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
}

@keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }
}

.acpWarning {
  /* border-radius: 0; */
  height: 30px;
  margin: 0px 0px 15px 0px !important;
}

.acpWarning > .el-alert__icon.is-big {
  font-size: 16px !important;
  width: 16px !important;
}

.acpWarning > div > .el-alert__description {
  font-size: 12px;
  margin: 0 0 0 0 !important;
}
/* rebuttal coder container table */
.coderContainerCard.coderContainerCard table tbody tr td {
  border: 1px solid #b4bccc !important;
}

.coderContainerCard.coderContainerCard table thead tr th {
  border-left: 1px solid #b4bccc !important;
  border-right: 1px solid #b4bccc !important;
}

.coderContainerCard.coderContainerCard .el-collapse-item__wrap {
  margin-top: 0px;
}
</style>
